import { createAsyncActionConstants } from 'utilities/util';

export const TYPES = {
    FETCH_EXPORT_JOB: createAsyncActionConstants('FETCH_EXPORT_JOB'),
    RESET_EXPORT_JOB: createAsyncActionConstants('RESET_EXPORT_JOB'),
    FETCH_EXPORT_JOB_DETAILS: createAsyncActionConstants('FETCH_EXPORT_JOB_DETAILS'),
    FETCH_EXPORT_JOB_DROPDOWN: createAsyncActionConstants('FETCH_EXPORT_JOB_DROPDOWN'),
    FETCH_EXPORT_JOB_DETAILS_CHARGES: createAsyncActionConstants('FETCH_EXPORT_JOB_DETAILS_CHARGES'),
    FETCH_EXPORT_JOB_DETAILS_BOOKING: createAsyncActionConstants('FETCH_EXPORT_JOB_DETAILS_BOOKING'),
    FETCH_EXPORT_JOB_DETAILS_CLR: createAsyncActionConstants('FETCH_EXPORT_JOB_DETAILS_CLR'),
    FETCH_EXPORT_JOB_DETAILS_CBL: createAsyncActionConstants('FETCH_EXPORT_JOB_DETAILS_CBL'),
    FETCH_EXPORT_JOB_DETAILS_ETS: createAsyncActionConstants('FETCH_EXPORT_JOB_DETAILS_ETS'),
    FETCH_EXPORT_JOB_DETAILS_INVOICE: createAsyncActionConstants('FETCH_EXPORT_JOB_DETAILS_INVOICE'),
    FETCH_EXPORT_JOB_SALES_ORDERS: createAsyncActionConstants('FETCH_EXPORT_JOB_SALES_ORDERS'),
    RESET_EXPORT_JOB_DETAILS: 'RESET_EXPORT_JOB_DETAILS',
    SET_EXPORT_JOB_SALES_ORDER_ID: 'SET_EXPORT_JOB_SALES_ORDER_ID',
    BULK_DOWNLOAD_EXPORT_JOBS: createAsyncActionConstants('BULK_DOWNLOAD_EXPORT_JOBS'),
    FETCH_RECONCILIATION_PO_DETAILS: createAsyncActionConstants('FETCH_RECONCILIATION_PO_DETAILS'),
    SALES_ORDER_EXPORT: createAsyncActionConstants('SALES_ORDER_EXPORT'),
    FETCH_NFTP_BILLABLE: createAsyncActionConstants('FETCH_NFTP_BILLABLE_EXPORT'),
}